// extracted by mini-css-extract-plugin
module.exports = {"profile-wrapper":"_1aJQO","profile-pic":"_2tbB1","profile-wrapper-circle":"ZK-I7","profile-circle":"O2Dra"};